import React from "react";
import { Warning } from "@phosphor-icons/react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info);
  }

  reset = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    const { fallback } = this.props;
    if (fallback) return fallback(this.state.error, this.reset);
    return (
      <div className="min-h-screen bg-paper flex items-center justify-center p-6" data-testid="error-boundary">
        <div className="elev-card p-8 max-w-md w-full text-center">
          <div className="w-12 h-12 rounded-full bg-[#A84A4A]/10 mx-auto mb-3 flex items-center justify-center">
            <Warning size={24} weight="duotone" className="text-[#A84A4A]" />
          </div>
          <h1 className="font-heading text-2xl font-medium text-[#1C2321]">Qualcosa è andato storto</h1>
          <p className="text-sm text-[#56635D] mt-2">Si è verificato un errore inatteso. Ricarica la pagina per riprovare.</p>
          <button onClick={this.reset} className="mt-6 bg-brand-700 hover:bg-brand-800 text-white px-5 py-2.5 rounded-lg text-sm">
            Ricarica pagina
          </button>
        </div>
      </div>
    );
  }
}
